import { IStampLoyaltyReward, LOYALTY_STAMPS_REWARD_TYPE } from 'features/cashier/services/types/stamp-loyalty';
import { formatCurrency } from 'utils/formatCurrency';

/** Nhãn ngắn của một mốc thưởng, dùng cho cả thanh stamp và modal chi tiết */
export const formatRewardLabel = (reward: IStampLoyaltyReward) => {
  switch (reward.rewardType) {
    case LOYALTY_STAMPS_REWARD_TYPE.PERCENTAGE_DISCOUNT:
      return `${reward.discountValue}% OFF`;
    case LOYALTY_STAMPS_REWARD_TYPE.AMOUNT_DISCOUNT:
      return `${formatCurrency(reward.discountValue)} OFF`;
    case LOYALTY_STAMPS_REWARD_TYPE.FREE_SERVICE:
      return `FREE ${reward.serviceName || 'SERVICE'}`;
    default:
      return '';
  }
};
